import React, { useEffect, useState } from "react";
import {
  collection,
  query,
  where,
  onSnapshot,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
  Timestamp,
} from "firebase/firestore";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  MenuItem,
  Select,
  Stack,
  TextField,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { db } from "../../firebase";
import { useAuth } from "../../contexts/AuthContext";
import TitleAlertsMobile from "../Titles/TitleAlertsMobile";
import AlertLineMobile from "../Lines/AlertLineMobile";

function AlertMobile2(props) {
  const clientID = props.clientId;
  const { currentUser } = useAuth();
  const [alerts, setAlerts] = useState([]);
  const [open, setOpen] = useState(false);
  const [editAlert, setEditAlert] = useState(null);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [alertToDelete, setAlertToDelete] = useState(null);

  const initialAlertData = {
    type: "",
    content: "",
    createdBy: currentUser.displayName,
    modifiedBy: "",
    isActive: true,
    clientID,
    createdAt: Timestamp.now(),
    clientIdentifier: props.clientIdentifier,
    firstName: props.firstName,
    lastName: props.lastName,
  };

  const [alertData, setAlertData] = useState(initialAlertData);

  const handleDeleteClose = () => {
    setOpenDeleteDialog(false);
  };

  useEffect(() => {
    if (clientID) {
      const alertsRef = collection(db, "clients", clientID, "alerts");
      const q = query(alertsRef, where("clientID", "==", clientID));
      const unsubscribe = onSnapshot(q, (querySnapshot) => {
        const alertsArray = [];
        querySnapshot.forEach((doc) => {
          alertsArray.push({ id: doc.id, ...doc.data() });
        });
        setAlerts(alertsArray);
      });

      return () => unsubscribe();
    }
  }, [clientID]);

  const handleClickOpen = (alert = null) => {
    if (alert) {
      setEditAlert(alert);
      setAlertData(alert);
    } else {
      setEditAlert(null);
      setAlertData(initialAlertData);
    }
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setEditAlert(null);
  };

  const getAlertTypeText = (type) => {
    switch (type) {
      case 1:
        return "Reminder";
      case 2:
        return "Allergy";
      case 3:
        return "Alert";
      default:
        return "Unknown";
    }
  };

  const handleSave = async () => {
    const alertsRef = collection(db, "clients", clientID, "alerts");
    const newAlert = {
      ...alertData,
      typeText: getAlertTypeText(alertData.type),
      modifiedBy: editAlert ? currentUser.displayName : "",
    };

    if (editAlert) {
      const alertRef = doc(alertsRef, editAlert.id);
      await updateDoc(alertRef, newAlert);
    } else {
      await addDoc(alertsRef, newAlert);
    }

    setOpen(false);
    setEditAlert(null);
  };

  const handleDeleteOpen = (alert) => {
    setAlertToDelete(alert);
    setOpenDeleteDialog(true);
  };

  const handleDeleteConfirm = async () => {
    if (alertToDelete) {
      await handleDelete(alertToDelete.id);
    }
    setOpenDeleteDialog(false);
  };

  const handleDelete = async (id) => {
    const alertRef = doc(db, "clients", clientID, "alerts", id);
    await deleteDoc(alertRef);
  };

  const renderAlerts = () =>
    alerts
      .sort(
        (a, b) =>
          Timestamp.fromMillis(b.createdAt.seconds * 1000).toDate() -
          Timestamp.fromMillis(a.createdAt.seconds * 1000).toDate()
      )
      .map((alert, index) => {
        let dateObject;
        if (alert.createdAt && alert.createdAt instanceof Timestamp) {
          dateObject = Timestamp.fromMillis(
            alert.createdAt.seconds * 1000
          ).toDate();
        } else {
          dateObject = new Date(alert.createdAt);
        }

        // if (!dateObject || isNaN(dateObject.getTime())) {
        //   return <div key={index}>Invalid Date</div>;
        // }

        const formattedDate =
          dateObject.toLocaleDateString("fr-FR") +
          " " +
          dateObject.toLocaleTimeString("fr-FR");
        console.log("dateObject : ", dateObject);
        console.log("timestamp alert : ", formattedDate);

        return (
          <div
            key={index}
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <div
              style={{ width: "90%" }}
              onClick={() => handleClickOpen(alert)}
            >
              <AlertLineMobile
                typeOfAlert={alert.type}
                notedBy={alert.createdBy}
                date={formattedDate}
                content={alert.content}
                color={alert.type}
              />
            </div>
            <Stack direction="row">
              <IconButton
                aria-label="delete"
                onClick={() => handleDeleteOpen(alert)}
              >
                <DeleteIcon />
              </IconButton>
            </Stack>
          </div>
        );
      });

  return (
    <div className="tab-container-white">
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          marginTop: 10,
          width: "95%",
          justifyContent: "space-between",
        }}
      >
        <Button
          variant="contained"
          color="primary"
          onClick={() => handleClickOpen()}
          style={{
            marginTop: 5,
            marginBottom: 5,
            marginLeft: 10,
            marginRight: 10,
          }}
        >
          Add Alert
        </Button>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          alignContent: "center",
          flexDirection: "column",
          width: "100%",
        }}
      >
        <div style={{ width: "100%", marginBottom: "15px", marginLeft: "0px" }}>
          <div style={{ width: "89%" }}>
            <TitleAlertsMobile />
          </div>

          {renderAlerts()}
        </div>
      </div>

      <div>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">
            {editAlert ? "Edit Alert" : "Add Alert"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText>Choose the type of alert</DialogContentText>
            <Select
              autoFocus
              margin="dense"
              id="type"
              label="Type"
              value={alertData.type}
              style={{ width: "150px", height: "30px" }}
              onChange={(e) =>
                setAlertData({ ...alertData, type: e.target.value })
              }
            >
              <MenuItem value={1}>Reminders</MenuItem>
              <MenuItem value={2}>Allergy</MenuItem>
              <MenuItem value={3}>Alert</MenuItem>
            </Select>
            <div style={{ marginTop: "20px" }}>
              <DialogContentText>
                Type the content of the alert
              </DialogContentText>
            </div>

            <TextField
              margin="dense"
              id="content"
              label="Content"
              type="text"
              fullWidth
              value={alertData.content}
              onChange={(e) =>
                setAlertData({ ...alertData, content: e.target.value })
              }
            />
            {editAlert && (
              <>
                <TextField
                  margin="dense"
                  id="createdBy"
                  label="Added By"
                  type="text"
                  fullWidth
                  value={editAlert.createdBy}
                  InputProps={{
                    readOnly: true,
                  }}
                />
                <TextField
                  margin="dense"
                  id="createdAt"
                  label="Date Added"
                  type="text"
                  fullWidth
                  value={new Date(editAlert.createdAt).toLocaleString()}
                  InputProps={{
                    readOnly: true,
                  }}
                />
              </>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Cancel
            </Button>
            <Button onClick={handleSave} color="primary">
              Save
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog open={openDeleteDialog} onClose={handleDeleteClose}>
          <DialogTitle id="alert-dialog-title">
            {"Confirm Deletion"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to delete this alert? This operation cannot
              be undone.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDeleteClose} color="primary" autoFocus>
              Cancel
            </Button>
            <Button onClick={handleDeleteConfirm} color="secondary">
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </div>
  );
}

export default AlertMobile2;
